import relaxCatalog from "../relax/catalog.json";
import { categoryMetadata } from "./registry";
import type { ToolCategory, ToolboxRoute } from "./types";

export function isToolboxPath(pathname: string): boolean {
  return (
    pathname === "/tools" ||
    pathname === "/tools/" ||
    pathname.startsWith("/tools/") ||
    pathname === "/workflows" ||
    pathname === "/workflows/" ||
    pathname.startsWith("/workflows/") ||
    pathname === "/relax" ||
    pathname.startsWith("/relax/")
  );
}

export function toolboxRouteFromPath(pathname: string): ToolboxRoute {
  if (pathname === "/relax" || pathname === "/relax/") return { kind: "relax" };
  if (/^\/relax\/slow\/?$/.test(pathname)) return { kind: "relax-slow" };
  const room = pathname.match(/^\/relax\/slow\/([a-f0-9]{32})\/?$/);
  if (room) return { kind: "relax-slow", slug: room[1] };
  if (pathname.startsWith("/relax/")) {
    const slug = pathname.slice("/relax/".length).replace(/\/$/, "");
    return relaxCatalog.some((item) => item.slug === slug)
      ? { kind: "relax-game", slug }
      : { kind: "not-found" };
  }
  if (pathname === "/workflows" || pathname === "/workflows/")
    return { kind: "workflows" };
  if (pathname.startsWith("/workflows/")) {
    const slug = decodeURIComponent(
      pathname.slice("/workflows/".length),
    ).replace(/^\/+|\/+$/g, "");
    return slug ? { kind: "workflow", slug } : { kind: "workflows" };
  }
  if (pathname === "/tools" || pathname === "/tools/") return { kind: "home" };
  if (!pathname.startsWith("/tools/")) return { kind: "not-found" };
  const slug = decodeURIComponent(pathname.slice("/tools/".length)).replace(
    /^\/+|\/+$/g,
    "",
  );
  if (slug.startsWith("category/")) {
    const category = slug.slice("category/".length);
    return isToolCategory(category)
      ? { kind: "category", category }
      : { kind: "not-found" };
  }
  return slug ? { kind: "tool", slug } : { kind: "home" };
}

export function workflowUrl(slug?: string): string {
  return slug ? `/workflows/${slug}` : "/workflows";
}

export function toolboxUrl(slug?: string): string {
  return slug ? `/tools/${slug}` : "/tools";
}

export function toolboxCategoryUrl(category: ToolCategory): string {
  return `/tools/category/${category}`;
}

function isToolCategory(value: string): value is ToolCategory {
  return Object.prototype.hasOwnProperty.call(categoryMetadata, value);
}
